<meta name="viewport" content="width=device-width, initial-scale=1.0" />
<div class="page-container top-fix resize-index start-column-vertical-centered-container min-height-100vh">
  <div class="content">
    <div class="white-card position-rel">
      <div class="login-content-terms-and-condition  column-gap-1p5em start-start-column-container">
        <div class="stretched-aligned-column-container column-gap-1p25em">
          <div class="header-text bold500">Update to our Terms & Policies</div>
          <div class="main-text">
           We’ve updated our <span class="link clickable" data-qa="link-terms-of-use"
                                       (click)="redirectTerms()">Terms of use</span> and
              <span class="link clickable" data-qa="link-privacy-policy" (click)="redirectPolicy()">Privacy Policy</span>.
            Please read them as they will apply to your use of the SerVC platform.
          </div>
        </div>
        <div class="space-between-horizontal-centered row-gap-0p5em">
          <app-checkbox data-qa="terms-and-conditions-checkbox" class="terms-checkbox"
                        [checked]="isUserAgreed"
                        (checkBoxClicked)="toggleIsUserAgreed()"></app-checkbox>
          <div class="main-text black-11">I have read everything and agree</div>
        </div>
          <app-button class = "width-100pcnt" data-qa="terms-of-use-btn"
                      [disabled]="!isUserAgreed"
                      [type]="'accent'"
                      [additionalClasses] = "'width-100pcnt'"
                      [bordersSquaredShape]="'full'"
                      [size]="'large'"
                      (buttonClick)="submit()">
            Continue
          </app-button>
      </div>
    </div>
  </div>
</div>
